import React from 'react'

const InputImage = (props) => {
    return (
        <input type={'file'} {...props}/>
    )
}

export default InputImage